
import Export1 from "../../../assets/outline/Export1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Export1Icon({ className, dataTestid = "Export1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Export1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
